import { toDisplayOddsDecimal } from './oddsFormat.js';

const roundOdds = value => toDisplayOddsDecimal(value) ?? 0;

const optionalNumber = (value) => {
  if (value === undefined || value === null || value === '') return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const optionalString = value => (
  value === undefined || value === null || value === '' ? null : String(value)
);

export const buildSportsnewBetSelectionPayload = selection => ({
  oddStateId: Number(selection.oddStateId ?? selection.odds_id ?? selection.id),
  providerOddId: optionalString(selection.providerOddId ?? selection.provider_odd_id),
  oddIdentityKey: optionalString(selection.oddIdentityKey ?? selection.odd_identity_key),
  shortOddId: optionalString(selection.shortOddId ?? selection.short_odd_id),
  canonicalSelectionKey: optionalString(selection.canonicalSelectionKey ?? selection.canonical_selection_key),
  canonicalLineKey: optionalString(selection.canonicalLineKey ?? selection.canonical_line_key),
  canonicalPairKey: optionalString(selection.canonicalPairKey ?? selection.canonical_pair_key),
  points: optionalNumber(selection.points),
  line: optionalNumber(selection.line),
  selectionLine: optionalString(selection.selectionLine ?? selection.selection_line),
  groupingKey: optionalString(selection.groupingKey ?? selection.grouping_key),
  expectedPriceDecimal: roundOdds(selection.odds ?? selection.priceDecimal ?? selection.price),
});

const buildSportsnewQuotePayload = ({
  selections,
  betType,
  bettingCategory,
  displayScope,
  betMode,
  stake,
}) => ({
  bet_type: betType,
  betting_category: bettingCategory,
  displayScope,
  scope: displayScope,
  betMode,
  stake,
  quotePurpose: 'combo_bonus_eligibility',
  selections: selections.map(buildSportsnewBetSelectionPayload),
});

export const buildBetQuotePreviewPayload = ({
  selections,
  betType,
  bettingCategory,
  displayScope,
  isSportsnew,
  betMode,
}) => isSportsnew ? buildSportsnewQuotePayload({
  selections,
  betType,
  bettingCategory,
  displayScope,
  betMode,
  // Combo-bonus eligibility depends on the selected odds, not the amount.
  // Keep the synthetic quote amount stable so typing a stake cannot invalidate
  // the authoritative bonus quote or start another network request.
  stake: 0,
}) : ({
  bet_type: betType,
  betting_category: bettingCategory,
  displayScope,
  scope: displayScope,
  stake: 0,
  selections: selections.map(selection => ({
    match_id: selection.match_id,
    market_id: selection.market_id,
    odds_id: selection.odds_id,
    requested_odds: Number(selection.odds),
  })),
});

export const buildSportsnewBetPlacementPreflightPayload = ({
  selections,
  betType,
  bettingCategory,
  displayScope,
  betMode,
  stake,
}) => buildSportsnewQuotePayload({
  selections,
  betType,
  bettingCategory,
  displayScope,
  betMode,
  stake: optionalNumber(stake) ?? 0,
});

export const buildBetQuotePreviewPayloadKey = payload => (
  payload ? JSON.stringify(payload) : ''
);
